import React from 'react'
import { Popup } from 'antd-mobile-v5'
import AuthorInfoCard from './AuthorInfoCard'

import styles from '../AllCards.module.css'

const StoryPopup = ({ story, setVisible, visible }) => {
  return <Popup
    visible={visible}
    onMaskClick={() => {
      setVisible(false)
    }}
    bodyStyle={{
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
    }}
  >
    <div className={styles.popup}>
      <div className={styles.close} onClick={() => setVisible(false)}></div>
      <div className={styles.name}>{story.name}</div>
      <img src={story.imageUrl} className={styles.img} />
      <div className={styles.story}>{story.story}</div>
      {JSON.stringify(story.author) !== '{}' && <AuthorInfoCard story={story} />}
    </div>
  </Popup>
}

export default StoryPopup